<template>
    <div>
        <template v-if="quotaReady && !serverOff && serverInit && filtersAvailable && filtersInit && licenseStatus && coursesReady && busketCurrencyReady && !getLocalizeError">
            <div class="header" v-html="header"></div>

            <!--Компонента основнова поиска-->
            <div v-if="settingsIsReady" class="content">
                <router-view/>
                <div v-show="!hasBasket">
                    <div v-show="resultType === 'hotels'" :class="['hotels-result', {'vertical-filters-mode flex relative': settings.FiltersDisplayOptions && !getWindowSettings.commonFiltersForHotels}]">
                        <template v-if="hotelsSearched && !(!searchedHotelsSecondFilters && !searchHotelsResult.length) || getWindowSettings.commonFiltersForHotels">
                            <hotels-second-search-bar :searched="hotelsSearched" @collapseByHotel="collapseByHotelForHotels = $event"/>
                        </template>

                        <hotels-result-list v-if="hotelsSearched"
                                          :collapseByHotel="collapseByHotelForHotels"
                                          :class="['result-list', {'vertical-filters flex-fill': settings.FiltersDisplayOptions}]"/>
                    </div>
                    <div v-show="resultType === 'tour'" :class="['tour-result', {'vertical-filters-mode flex relative': settings.FiltersDisplayOptions && !getWindowSettings.commonFilters}]">
                        <!--Компонента с доп. филтрами-->
                        <template v-if="searched && !(!searchedSecondFilters && !searchResult.length) || getWindowSettings.commonFilters">
                            <second-search-bar :searched="searched" @collapseByHotel="collapseByHotel = $event"/>
                        </template>


                        <!--Компонента для показа результатов поиска-->
                        <tour-result-list v-if="searched"
                                          :collapseByHotel="collapseByHotel"
                                          :class="['result-list', {'vertical-filters flex-fill': settings.FiltersDisplayOptions}]"/>
                    </div>
                    <div v-show="resultType === 'tickets'" :class="['tickets-result', {'vertical-filters': settings.FiltersDisplayOptions}]">
                        <!--Компонента с доп. филтрами-->
                        <tickets-second-search-bar v-if="searchedTickets"/>

                        <!--Компонента для показа результатов поиска-->
                        <ticket-result-list class="result-list"
                                            v-if="searchedTickets"/>
                    </div>
                    <div v-show="resultType === 'quotes' && getShowQuotes" :class="'quotes-result'">
                        <!--Компонент для показа результатов поиска-->
                        <quotes-result-list/>
                    </div>
                </div>
                <div v-show="hasBasket">
                    <basket/>
                </div>
            </div>

            <div class="footer" v-html="footer"></div>

            <!--Лоадер для запросов-->
            <page-loader v-if="pageLoaderStatus"/>

            <!--Компонента прелоадер-->
            <pre-loader :status="preLoaderStatus"/>
        </template>

        <!--Показываем блок с ошибкой, когда не инициолезирован кеш или не запушен-->
        <div class="error-wrap" v-else>
            <div class="server-off">
                <h1 class="error-title mt-10 mb-5">
                    {{ localizeList.errorUpper || 'Ошибка' }}
                </h1>

                <h3 v-if="!quotaReady" class="error-text">
                    {{ localizeList.quotasServiceIsUnavailable }}
                </h3>
                <h3 v-else-if="serverOff" class="error-text">
                    {{ localizeList.searchServiceIsUnavailable }}
                </h3>
                <h3 v-else-if="!serverInit" class="error-text">
                    {{ localizeList.searchServiceCacheIsNotInitialized }}
                </h3>
                <h3 v-else-if="!filtersAvailable" class="error-text">
                    {{ localizeList.actualFiltersServiceUnavailable }}
                </h3>
                <h3 v-else-if="!filtersInit" class="error-text">
                    {{ localizeList.actualFiltersServiceCacheIsNotInitialized }}
                </h3>
                <h3 v-else-if="!licenseStatus" class="error-text">
                    {{ localizeList.licenseExpired }}
                </h3>
                <h3 v-else-if="!coursesReady" class="error-text">
                    {{ localizeList.ratesDidntFound }}
                </h3>
                <h3 v-else-if="!busketCurrencyReady" class="error-text">
                    {{ localizeList.bascketCurrencyDidntFound }}
                </h3>
                <h3 v-else-if="getLocalizeError" class="error-text">
                    Отсутствует локализация «{{localizeCode}}», заданная по умолчанию.
                </h3>
            </div>
        </div>

        <!--Компонента для показывания всплываюшего облочко стекстом(можно использовать в любойчасти кода)-->
        <popover :show="popover.show"
                 :text="popover.text"
                 :height="popover.height"
                 :nowrap="popover.nowrap"
                 :pre-type="popover.preType"
                 :down="popover.down"
                 :x="popover.x"
                 :y="popover.y"/>

        <!--Вставляем название компании-->
        <div class="company-name">
            © {{ localizeList.megatecUpper }}, 1996–{{ new Date().getFullYear() }},
            <a :href="mt15link" target="_blank"> Мастер-Тур 15</a>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {bus} from '../main'

    import popover from "../views/baseComponents/popover";
    import pageLoader from "../views/baseComponents/pageLoader";
    import preLoader from "../views/baseComponents/preLoader";
    import secondSearchBar from "../views/tour/secondFilters/secondSearchBar";
    import tourResultList from "../views/tour/tourResult/tourResultList";
    import basket from "../views/basket/basket";
    import ticketResultList from "../views/tickets/ticketResultList";
    import ticketsSecondSearchBar from "../views/tickets/ticketsSecondSearchBar";
    import quotesResultList from "../views/quotes/quotesResultList";
    import hotelsSecondSearchBar from "../views/hotels/secondFilters/secondSearchBar";
    import hotelsResultList from "../views/hotels/tourResult/tourResultList";


    import * as typesGlobal from "@/stores/types";

    export default {
        components: {
            popover,
            pageLoader,
            preLoader,
            secondSearchBar,
            tourResultList,
            basket,
            ticketResultList,
            ticketsSecondSearchBar,
            quotesResultList,
            hotelsSecondSearchBar,
            hotelsResultList
        },
        data() {
            return {
                staticSearchResult: [],
                staticHotelsSearchResult: [],
                preLoaderStatus: true,
                header: "",
                footer: "",
                pageLoaderStatus: false,
                resultType: "tour",
                debug: Vue.config.debug,
                localizeCode: document.getElementById('defaultLanguageCode').value,
                listTypeCode: '',
                settingsIsReady: false,
                collapseByHotel: false,
                collapseByHotelForHotels: false
            }
        },
        created() {
            if (this.getWindowSettings.commonFilters && this.getWindowSettings.easySearchFilter) window.settings.easySearchFilter = false;
            if (this.getWindowSettings.commonFiltersForHotels && this.getWindowSettings.easySearchFilterForHotels) window.settings.easySearchFilterForHotels = false;

            let apiOrigin = window.location.origin + "/";
            if (this.debug)
                apiOrigin = "http://localhost/";

            let path = window.location.pathname;
            if (this.debug)
                path = 'TourSearchClient2';

            if (!this.debug){
                const append = (res, type) => {
                    let html = res.data.split('\n');
                    html = html.filter(x => !x.match(/^(\/\/)/)).join('\n');

                    let script = html.split("script>")?.[1]?.split("</")?.[0];
                    if (script) eval(script);

                    if (type === 'header')
                        this.header = html;
                    else
                        this.footer = html;
                };

                const hasHeader = document.body.classList.contains('has-header');
                const hasFooter = document.body.classList.contains('has-footer');

                if (hasHeader) {
                    Vue.Api.Get(apiOrigin + path + '/header.js')
                            .then(res => {
                                append(res, 'header')
                            });
                }
                if (hasFooter) {
                    Vue.Api.Get(apiOrigin + path + '/footer.js')
                            .then(res => {
                                append(res, 'footer')
                            })
                }
            }

            /*установка языка */
            let localCode = localStorage.getItem("localize") || document.getElementById('defaultLanguageCode').value;
            this.$store.dispatch(typesGlobal.A_SET_SETTINGS, localCode)
                .then(() => {
                    this.preLoaderStatus = false;
                    this.settingsIsReady = true;

                    this.$nextTick(() => {
                        if (this.settings?.FiltersDisplayOptions && !this.hasBasket)
                            document.body.classList.add('vertical-filters')
                    })
                })
                .catch(() => {
                    this.$store.dispatch(typesGlobal.A_SET_SERVER_OFF)
                });

            this.setListType();

            bus.$on("page-load", (val) => {
                this.pageLoaderStatus = val
            });
            bus.$on("change-search-type", (type) => {
                this.resultType = type
            });

            this.correctingRateInStorage();

            this.setBusketCurrency();

            this.getQuotaServices();

            this.setConfigUrls();

            this.getCurrencyRates();
        },
        updated() {
            this.$nextTick(() => {
                const isTicketFromBasket = location.href.includes("Basket") && !location.href.includes("hotelQuota");

                if (this.$route.path.includes("Individuals/Avia") || isTicketFromBasket) {
                    this.resultType = "tickets"
                } else if (this.$route.path.includes("Individuals/Quotes")) {
                    this.resultType = "quotes"
                } else if (this.$route.path.includes("Individuals/Hotels")) {
                    this.resultType = "hotels"
                } else {
                    this.resultType = "tour"
                }
            })
        },
        computed: {
            getShowQuotes() {
                return this.$store.getters['quotes/getShowQuotes']
            },
            getWindowSettings() {
                return window.settings;
            },
            getShowTourResultList(){
                return this.$store.getters['tour/getShowTourResultList']
            },
            mt15link() {
                const mt15 = "https://www.megatec.ru/mastertour15";
                const hostName = window.location.hostname;
                return `${mt15}?utm_source=${hostName}`;
            },
            settings() {
                return this.$store.getters['getSettings'];
            },
            hasBasket() {
                return this.$route.fullPath.includes("Basket") || false
            },
            token() {
                return this.$store.getters['getToken']
            },
            quotaReady() {
                return this.$store.getters['getQuotaReady']
            },
            coursesReady() {
                let r = true;
                let getCurrency = this.$store.getters['getCurrency'];

                if (getCurrency !== null) {
                    r = getCurrency.length || !this.$store.getters['getCoursesReady']
                }
                return r;
            },
            getLocalizeError(){
                return this.$store.getters['getLocalizeError'];
            },
            busketCurrencyReady(){
                return this.$store.getters['getBusketCurrencyReady'];
            },
            serverOff() {
                return this.$store.getters['getServerOff']
            },
            serverInit() {
                return this.$store.getters['getServerInit']
            },
            filtersAvailable() {
                return this.$store.getters['getFiltersAvailable']
            },
            filtersInit() {
                return this.$store.getters['getFiltersInit']
            },
            licenseStatus() {
                // return true;
                return this.$store.getters['getLicenseStatus']
            },
            searched() {
                return this.$store.getters['tour/getSearched']
            },
            hotelsSearched() {
                return this.$store.getters['hotels/getSearched']
            },
            searchedTickets() {
                return this.$store.getters['tickets/getSearched']
            },
            searchedSecondFilters() {
                return this.$store.getters['tour/getSearchedSecondFilters']
            },
            searchedHotelsSecondFilters() {
                return this.$store.getters['hotels/getSearchedSecondFilters']
            },
            searchResult: {
                get() {
                    let res = [];
                    this.$store.getters['tour/getSearchResult'].forEach(x => {
                        res.push(x)
                    })
                    this.staticSearchResult.forEach(x => {
                        res.push(x)
                    })
                    return res
                },
                set(val) {
                    this.staticSearchResult = val
                }
            },
            searchHotelsResult: {
                get() {
                    let res = [];
                    this.$store.getters['hotels/getSearchResult'].forEach(x => {
                        res.push(x)
                    })
                    this.staticHotelsSearchResult.forEach(x => {
                        res.push(x)
                    })
                    return res
                },
                set(val) {
                    this.staticHotelsSearchResult = val
                }
            },
            popover() {
                return this.$store.getters['getPopover']
            }
        },
        methods:{
            correctingRateInStorage() {
                if (localStorage.getItem("Rate") === "undefined") {
                    localStorage.setItem("Rate", null)
                }
            },
            getCurrencyRates() {
                this.$store.dispatch("A_SET_CURRENCY_RATES");
            },
            setListType() {
                const listTypes = ['big-row','grid','row','map'];

                // let configListType = document.getElementById('defaultDisplaySearchResults').value;
                let configListType = window.settings.defaultDisplaySearchResults;
                configListType = configListType ? configListType.toLowerCase() : configListType;
                configListType = configListType === 'list' ? 'row' : configListType;

                let sessionListType = sessionStorage.getItem('listType');
                sessionListType = sessionListType ? sessionListType.toLowerCase() : sessionListType;

                this.listTypeCode = sessionListType || configListType;

                if (!listTypes.includes(this.listTypeCode)) {
                    this.listTypeCode = 'grid';
                    sessionStorage.setItem('listType', this.listTypeCode);
                }
                if (!sessionListType) {
                    sessionStorage.setItem('listType', this.listTypeCode);
                }
            },
            getQuotaServices() {
                this.$store.dispatch('A_GET_QUOTA_SERVICES');
            },
            setConfigUrls() {
                this.$store.dispatch('A_SET_CONFIG_URLS');
            },
            setBusketCurrency() {
                this.$store.dispatch('A_SET_BUSKET_CURRENCY');
            }
        },
        watch: {
            hasBasket(val) {
                if (val) {
                    document.body.classList.remove('vertical-filters')
                } else {
                    if (this.settings?.FiltersDisplayOptions)
                        document.body.classList.add('vertical-filters')
                }
            }
        }
    }
</script>

<style scoped>

    .result-list {
        min-height: calc(100vh - 192px);
    }

    .space-height {
        min-height: 500px;
    }

    .empty-result {
        margin: 20px 60px;
        padding: 16px;
        background: var(--lighten-6-color);
        font-size: 18px;
    }

    .company-name {
        background: #d8d9dd;
        font-size: 11px;
        color: #999;
        display: flex;
        justify-content: center;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 100;
        height: 16.2px;
    }

    .company-name a {
        color: #428bca;
        margin-left: 4px;
    }

    .error-wrap {
        padding-top: 28px;
        display: flex;
        justify-content: center;
    }

    .server-off {
        width: 90vw;
        min-width: 970px;
        max-width: 1210px;
        background-color: #eee;
        border-radius: 6px;
        padding: 48px 60px;
    }

    .server-off .error-title {
        font-size: 63px;
        color: #333;
        font-family: Helvetica, Arial, sans-serif;
        font-weight: 500;
    }

    .server-off .error-text {
        font-size: 24px;
        color: #333;
        margin: 20px 0 10px;
        font-family: Helvetica, Arial, sans-serif;
        font-weight: 500;
    }

    /*.vertical-filters-mode {*/
    /*    flex-wrap: wrap;*/
    /*}*/

    .vertical-filters-mode /deep/ #second-search-bar.price-table-show, .vertical-filters-mode /deep/ #hotels-second-search-bar.price-table-show {
        width: 100%;
        display: flex;
        align-items: flex-start;
    }

    .vertical-filters-mode /deep/ #price-table, .vertical-filters-mode /deep/ #hotels-price-table {
        flex: 1;
        margin: 18px 60px 0 0;
        background-color: var(--white-color);
        padding: 20px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
        border-radius: 6px;
    }

    .tour-result,
    .hotels-result {
        position: relative;
    }

    .tickets-result.vertical-filters {
        display: flex;
        position: relative;
    }

    .tickets-result.vertical-filters.date-table-open {
        display: block;
    }

    .tickets-result.vertical-filters .result-content {
        flex: 1;
    }
</style>
